import axios from 'axios'
import * as firebase from 'firebase/app'
import {
  AUTHENTICATE,
  authenticate,
  UNAUTHENTICATE
} from './authActions'

const apiUrl = 'http://localhost:8080/advertiser/'

export const GET_ADVERTISER = 'GET_ADVERTISER'
export const NEW_ADVERTISER = 'NEW_ADVERTISER'

/**
 * @param { string } paramKey parameter to lookup advertiser
 * @param { any }    paramVal identifier to lookup advertiser
 */
export const getAdvertiser = (paramKey, paramVal) => {
  const config = {
    params: {
      [paramKey]: paramVal
    }
  }
  return (dispatch) => {
    return axios.get(`${apiUrl}`, config)
      .then(response => {
        dispatch({ type: GET_ADVERTISER, advertiser: response.data[0] })
      })
      .catch(error => {
        console.log(error)
        // throw (error)
      })
  }
}

export const advertiserExists = (paramKey, paramVal) => {
  const config = {
    params: {
      [paramKey]: paramVal
    }
  }
  return (dispatch) => {
    return axios.get(`${apiUrl}`, config)
      .then(response => {
        return {
          exists: response.data.length > 0,
          advertiser: response.data[0]
        }
      })
      .catch(error => {
        console.log(error)
        return {
          exists: false,
          advertiser: null
        }
      })
  }
}

export const newAdvertiser = (advertiserObject) => {
  const email = advertiserObject.contact_email
  const password = advertiserObject.password
  delete advertiserObject.password
  console.log(JSON.stringify(advertiserObject))
  console.log(`password: ${password}`)
  return (dispatch) => {
    return axios.post(`${apiUrl}`, advertiserObject)
      .then(response => {
        dispatch({ type: NEW_ADVERTISER, newAdvertiser: advertiserObject })
      })
      .then(() => {
        console.log(`password: ${password}`)
        console.log('creating user w email and password via firebase auth')
        firebase.auth()
          .createUserWithEmailAndPassword(email, password)
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code
            var errorMessage = error.message
            console.log(`${errorCode}: ${errorMessage} / ${password}`)
          })
      })
      .then(() => {
        console.log('firebase dispatching auth')
        authenticate()
        // dispatch({ type: AUTHENTICATE, authenticated: true })
      })
      .catch(error => {
        console.log(`error posting advertiser: ${error}`)
        dispatch({ type: AUTHENTICATE, authenticated: false })
        // throw (error)
      })
  }
}
